export default {
  "home": "ДОМОЙ",
  "news": "НОВОСТИ",
  "community": "СООБЩЕСТВО",
  "character": "ПЕРСОНАЖИ",
  "world": "НАСТРОЙКИ МИРА",
  "features": "ФУНКЦИИ",
  "topUp": "ПОПОЛНЕНИЕ",
  "customerService": "СЛУЖБА ПОДДЕРЖКИ",
  "download": "СКАЧАТЬ",
  "moreDownload": "Другие способы загрузки",
  "screenshot": "СКРИНШОТ",
  "video": "СИНЕМАТИК",
  "poster": "ПЛАКАТ",
  "downloadGame": "СКАЧАТЬ",
  "scan": "Отсканируйте QR-код, чтобы скачать",
  "prev": "Пред.",
  "next": "След.",
  "moreNews": "ИНФОРМАЦИЯ",
  "latest": "НОВИНКИ",
  "fwtk": "TERMS OF SERVICE",
  "yszc": "PRIVACY POLICY",
  "noContent": "Пока нет содержания",
  "goPay": "ВПЕРЁД",
  "payGuide": "УЗНАТЬ БОЛЬШЕ",
  "stayTurn": "Пока нет содержания",
  "huoyi": "Огненный муравей",
  "huoyi_text": "Огненный муравей — один из самых известных инвазивных видов в мире, который бояться муравьи всех размеров.\r\nХоть они и небольших размеров (общая длина ~ 4-6 мм), поэтому кажутся безобидными, они очень агрессивны и разрушительны.",
  "huoyi_skill1": "Тактики",
  "huoyi_skill2": "Здоровье солдата-разведчика",
  "huoyi_skill3": "Защита солдата-разведчика",
  "huoyi_skill4": "Атака солдата-разведчика ",
  "ciyi": "Янтарное жало",
  "ciyi_text": "Polyrhachis trapezoidea обычно встречается в эвкалиптовых лесах и саванах Австралии. На спинке у него золотисто-оранжевая щетина.\r\nПо краям спины находятся похожие на панцирь шипы, они прочные и хорошо защищают от врагов.",
  "ciyi_skill1": "Тактики",
  "ciyi_skill2": "Здоровье солдата-стрелка",
  "ciyi_skill3": "Защита солдата-стрелка",
  "ciyi_skill4": "Атака солдата-стрелка ",
  "hongyi": "Мясной муравей",
  "hongyi_text": "Monomorium sp, таинственный вид, еще не имеющий своего названия. Может достигать 8 мм в длину и имеет узнаваемый рисунок в виде капли крови на спине.",
  "hongyi_skill1": "Скорость исследований",
  "hongyi_skill2": "Скорость обучения",
  "hongyi_skill3": "Макс. размер армии",
  "jinjia": "Жнец",
  "jinjia_text": "Daceton armigerum, или древесные плотоядные муравьи, обитают в тропических лесах Амазонки на севере Южной Америки.\r\nРазмер муравьев-рабочих и солдат отличается, они могут достигать 15-17 мм.\r\nИх рацион разнообразен, от насекомых до мелких улиток.\r\nОни могут не только разрывать добычу сильными и мощными зубами, но также жалить и впрыскивать яд.",
  "jinjia_skill1": "Тактики",
  "jinjia_skill2": "Здоровье солдата-бойца",
  "jinjia_skill3": "Защита солдата-бойца",
  "jinjia_skill4": "Атака солдата-бойца ",
  "gongbei": "Древоточец",
  "gongbei_text": "Camponotus mirabilis встречается на севере Южной Америки, их еще называют призраками тропических лесов Амазонки.\r\nОни разводят тлю в бамбуковых зарослях и собирают их нектар, который употребляют в пищу. Изредка охотятся на других насекомых.",
  "gongbei_skill1": "Скорость обучения",
  "gongbei_skill2": "Снижение пищи на обучение",
  "gongbei_skill3": "Снижение затрат выносливости",
  "specialAnt": "Особый муравей",
  "back": "Назад",
  "guide": "РУКОВОДСТВО",
  "announcement": "ОБЪЯВЛЕНИЯ",
  "event": 'СОБЫТИЯ',
}
